import { CommonModule } from '@angular/common';
import {
    TgButtons2Module,
    TgFormsModule,
    TgGridModule,
    TgModalModule,
    TgSpacingModule
} from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { StartOverModule } from '../start-over/start-over.module';
import { StartOverButtonComponent } from './start-over-button.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgModalModule,
        TgFormsModule,
        TgSpacingModule,
        TgButtons2Module,
        StartOverModule
    ],
    declarations: [
        StartOverButtonComponent
    ],
    exports: [StartOverButtonComponent]
})
export class StartOverButtonModule {
}
